import { SVGProps } from 'react';

export default function OutdoorUnitIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
      aria-hidden='true'
      {...props}
    >
      <rect x='3' y='4.5' width='18' height='15' rx='2' />
      <circle cx='12' cy='12' r='4.5' />
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M12 12V8.25M12 12l3.25 1.875M12 12l-3.25 1.875'
      />
    </svg>
  );
}
